"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.updateConfig = exports.getConfig = exports.DEFAULT_PROPS = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread")),
    _d = require("d3"),
    _util = require("../util/"),
    DEFAULT_PROPS = {
  value: 0,
  minValue: 0,
  maxValue: 1e3,
  forceRender: !1,
  width: 300,
  height: 300,
  paddingHorizontal: 0,
  paddingVertical: 0,
  fluidWidth: !1,
  dimensionUnit: "px",
  segments: 5,
  maxSegmentLabels: -1,
  customSegmentStops: [],
  needleColor: "steelblue",
  startColor: "#FF471A",
  endColor: "#33CC33",
  segmentColors: [],
  needleTransition: "easeQuadInOut",
  needleTransitionDuration: 500,
  needleHeightRatio: .9,
  ringWidth: 60,
  textColor: "#666",
  valueFormat: "",
  currentValueText: "${value}",
  currentValuePlaceholderStyle: "${value}",
  labelFontSize: "14px",
  valueTextFontSize: "16px"
};

exports.DEFAULT_PROPS = DEFAULT_PROPS;

var DEFAULT_CONFIG = {
  ringInset: 20,
  pointerWidth: 10,
  pointerTailLength: 5,
  minAngle: -90,
  maxAngle: 90,
  labelInset: 10
},
    getConfig = function getConfig(a) {
  var b = a.PROPS,
      c = a.parentWidth,
      d = a.parentHeight,
      e = {
    width: b.fluidWidth ? c : b.width,
    height: b.fluidWidth ? d : b.height,
    paddingHorizontal: b.paddingHorizontal,
    paddingVertical: b.paddingVertical,
    dimensionUnit: b.dimensionUnit,
    ringWidth: b.ringWidth,
    minValue: b.minValue,
    maxValue: b.maxValue,
    needleColor: b.needleColor,
    majorTicks: b.segments,
    customSegmentStops: b.customSegmentStops,
    maxSegmentLabels: (0, _util.calculateSegmentLabelCount)({
      maxSegmentLabelCount: b.maxSegmentLabels,
      segmentCount: b.segments
    }),
    segmentColors: b.segmentColors,
    arcColorFn: 0 < b.segmentColors.length ? (0, _d.scaleQuantize)(b.segmentColors) : (0, _d.interpolateHsl)((0, _d.rgb)(b.startColor), (0, _d.rgb)(b.endColor)),
    needleTransition: b.needleTransition,
    needleTransitionDuration: b.needleTransitionDuration,
    needleHeightRatio: b.needleHeightRatio,
    textColor: b.textColor,
    labelFormat: (0, _d.format)(b.valueFormat),
    currentValueText: b.currentValueText,
    currentValuePlaceholderStyle: b.currentValuePlaceholderStyle,
    labelFontSize: b.labelFontSize,
    valueTextFontSize: b.valueTextFontSize
  };
  return Object.assign({}, DEFAULT_CONFIG, e);
};

exports.getConfig = getConfig;

var updateConfig = function updateConfig(a, b) {
  return (0, _objectSpread2["default"])({}, a, b);
};

exports.updateConfig = updateConfig;